import React from 'react'
import { TouchableOpacity, StyleSheet } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Icon, Text } from '@components'
import { useScreen } from '@hooks'

interface GhostTabButtonProps {
  iconName: string
  label: string
  isSelected: boolean
  disabled?: boolean
  onPress: () => void
}

export const GhostTabButton: React.FC<GhostTabButtonProps> = ({
  iconName,
  label,
  isSelected,
  disabled,
  onPress,
}) => {
  const theme = useTheme()
  const styles = getStyle(theme)
  const { isDesktop } = useScreen()

  return (
    <TouchableOpacity
      style={[
        isSelected ? styles.actionButton : styles.actionButtonTransparent,
        !isDesktop && styles.actionButtonMobile,
        isDesktop && {
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: theme.spacing.md,
          paddingVertical: theme.spacing.lg,
        },
        disabled && { opacity: 0.5 },
      ]}
      onPress={onPress}
      disabled={disabled}
    >
      <Icon name={iconName as any} size={theme.iconSize.medium} color={theme.colors.secondary} />
      <Text type="bodySmall" color={theme.colors.secondary} numberOfLines={1} ellipsizeMode="tail">
        {label}
      </Text>
    </TouchableOpacity>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    actionButton: {
      alignItems: 'center',
      gap: 5,
      paddingVertical: theme.spacing.md,
      paddingHorizontal: theme.spacing.lg,
      backgroundColor: 'rgba(0,0,0, 0.03)',
      borderRadius: theme.spacing.lg,
    },
    actionButtonTransparent: {
      alignItems: 'center',
      gap: 5,
      paddingVertical: theme.spacing.md,
      paddingHorizontal: theme.spacing.lg,
      borderRadius: theme.spacing.lg,
    },
    actionButtonMobile: {
      flex: 1,
      paddingHorizontal: theme.spacing.xs,
      minWidth: 0,
    },
  })
